
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"41","height":"42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Subtraction 24","d":"M20.5 42A20.123 20.123 0 016 35.849a21.365 21.365 0 010-29.7 20.156 20.156 0 0128.991 0 21.362 21.362 0 010 29.7A20.122 20.122 0 0120.5 42zM13.252 8.614a4.621 4.621 0 00-4.62 4.611v14.639a4.621 4.621 0 004.62 4.611h14.664a4.621 4.621 0 004.62-4.611V13.226a4.622 4.622 0 00-4.623-4.611zm14.662 21.531H13.252a2.29 2.29 0 01-2.294-2.281V18.1h3.57a6.388 6.388 0 00-.483 2.442 6.537 6.537 0 0013.074 0 6.377 6.377 0 00-.485-2.442h3.574v9.766a2.289 2.289 0 01-2.294 2.279zm-7.332-5.4a4.193 4.193 0 01-3.412-6.648 4.2 4.2 0 016.824 0 4.167 4.167 0 01.8 2.442 4.21 4.21 0 01-4.212 4.203zm5.152-9.323l-.013-4.047 3.521-.01h.531v4.045z","fill":"#fff"}})])
          )
        }
      }
    